<template lang="pug">
  div.tree-folder-content
    ul.category.level(:class="`level_${level}`")
      li(v-for="item in cate")
        div.header
          div.name
            a(@click.prevent="go(item)") {{item.name}}
            button.button-toggle.fa.fa-minus(v-if="item.items")
            button.button-toggle.fa.fa-plus(v-if="item.items")
        TreeFolder(v-if="item.items",
                  :category="item.items", :level="level + 1")
        //- Special(v-if="item.items" :menu="menu",style="display:none")
</template>
<script>
export default {
  name: 'TreeFolderContent',
  props: ['cate', 'level', 'toggleNavFold'],
  methods: {
    go (item) {
      if (item.link.indexOf('stance.tmall.com') > -1) {
        window.open(item.link)
      } else {
        // if(item.items){
        //   this.menu = item.items;
        //   for(var i in this.menu){
        //     this.menu[i].parentId = item.id
        //   }
        // }
        let link = `/${item.route}/${item.name}?parent=${item.parent}&id=${item.id}`
        this.$router.push({
          path: link
        }, () => {
          this.$store.dispatch('toggleShowNavigation')
        })
      }
    }
  },

  components: {
    TreeFolder: () => import('./TreeFolder.vue')
  }
}
</script>

<style lang="scss" scoped>
.name {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.tree-folder-content {
  padding-left: 1rem;
}
button {
  background: transparent;
  border: none;
}
a:hover {
  cursor: pointer;
}
</style>
